import { DownloadLoanAgreementProps, InvestInPrimaryMarketItemProps } from 'models/api';

import BaseApi from './BaseApi';
import { AxiosError, AxiosResponse } from 'axios';

export class LoansApi extends BaseApi {
	constructor() {
		super('/loans');
	}
	invest({ id, body }: InvestInPrimaryMarketItemProps) {
		return this.httpClient.post({
			url: `/${id}`,
			conditions: { auth: true },
			body,
		});
	}

	getAgreement({ amount, id }: DownloadLoanAgreementProps) {
		return this.httpClient
			.get({
				url: `/${id}/agreement/${amount}`,
				conditions: { auth: true },
				config: {
					responseType: 'blob',
				},
			})
			.catch(async (error: AxiosError<any>) => {
				throw new AxiosError(error.message, error.code, error.config, error.request, {
					...error.response,
					data: JSON.parse(await error.response?.data.text()),
				} as AxiosResponse);
			});
	}
}
export const LoansService = new LoansApi();
